module.exports = __webpack_public_path__ + "static/fonts/iconfont.ed03f47d.woff2";